import type { RightPanelKind } from '../../store/rightPanelSlice';

/** What Files list should put in the right panel for current selection + mode. */
export type FilesRightPanelAction =
  'fileDetail' | 'aiSummary' | 'aiDocumentChat' | 'multiSelected' | 'selectItem' | 'close';

/**
 * Selection sync for Files right panel.
 * Chat / summary mode: 1 → that view, >1 → N selected, 0 → close.
 * Detail mode: 1 → FileDetail, >1 → N selected, 0 → select-item hint.
 */
export function resolveFilesRightPanelAction(
  kind: RightPanelKind,
  selectedCount: number,
): FilesRightPanelAction {
  if (kind === 'aiDocumentChat') {
    if (selectedCount === 1) return 'aiDocumentChat';
    if (selectedCount > 1) return 'multiSelected';
    return 'close';
  }
  if (kind === 'aiSummary') {
    if (selectedCount === 1) return 'aiSummary';
    if (selectedCount > 1) return 'multiSelected';
    return 'close';
  }
  if (selectedCount === 1) return 'fileDetail';
  if (selectedCount > 1) return 'multiSelected';
  return 'selectItem';
}
